import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import AddressInputs from './AddressInputs';
import EmailInputs from './EmailInputs';
import PropTypes from 'prop-types';

import NameInputs from './NameInputs';
import PhoneNumberInputs from './PhoneNumberInputs';
import ContactPreference from './ContactPreference';
import GiftAidEligibility from './GiftAidEligibility';
import LeadSource from './LeadSource';
import Flex from 'components/common/Flex';

const CreateDonarForm = ({ sectionRefs }) => {
  const [validated, setValidated] = useState(false);

  const handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <div id={'name'} ref={sectionRefs[1]}>
        <NameInputs />
      </div>
      <div id={'address'} ref={sectionRefs[2]}>
        <AddressInputs />
      </div>
      <div id={'phone_number'} ref={sectionRefs[3]}>
        <PhoneNumberInputs />
      </div>
      <div id={'email_address'} ref={sectionRefs[4]}>
        <EmailInputs />
      </div>
      <div id={'contact_preference'} ref={sectionRefs[5]}>
        <ContactPreference />
      </div>
      <div id={'gift_aid'} ref={sectionRefs[6]}>
        <GiftAidEligibility />
      </div>
      <div id={'source'} ref={sectionRefs[7]}>
        <LeadSource />
      </div>
      <Card>
        <Card.Body>
          <Flex justifyContent={'between'} alignItems={'center'}>
            <h5 className="mb-0 fs-0 fs-md-1">Create The New Donor</h5>
            <Button type="submit" className="btn btn-primary">
              Create Now
            </Button>
          </Flex>
        </Card.Body>
      </Card>
    </Form>
  );
};
CreateDonarForm.propTypes = { sectionRefs: PropTypes.array };
export default CreateDonarForm;
